import intance from '../util/axios';

export const forgotPassword = async (value, headers) => {
  const URL = `auth/forgot-password`;
  const response = await intance.post(URL, value, { headers });
  return response;
};

export const otpVerification = async (value, headers) => {
  const URL = `auth/confirm-otp`;
  const response = await intance.post(URL, value, { headers });
  return response;
};

export const resetPassword = async (value, headers) => {
  const URL = `auth/reset-password`;
  const response = await intance.post(URL, value, { headers });
  return response;
};

export const Logout = async (headers) => {
  const URL = `admin/logout`;
  const response = await intance.get(URL, { headers });
  return response;
};

export const forceLogoutUser = async (user_id) => {
  const URL = `auth/logout`;
  const response = await intance.post(URL, { user_id });
  return response;
};

export const checkEmail = async (value, config = {}) => {
  const URL = `auth/check-email`;
  const response = await intance.post(URL, value, config);
  return response;
};

export const sendOtp = async (value) => {
  const URL = `auth/send-otp`;
  const response = await intance.post(URL, value);
  return response;
};

export const verifyOtp = async (value) => {
  const URL = `auth/verify-otp`;
  const response = await intance.post(URL, value);
  return response;
};

export const setPassword = async (value) => {
  const URL = `auth/set-password`;
  const response = await intance.post(URL, value);
  return response;
};

export const sendVerificationEmail = async (value) => {
  const URL = `auth/send-verification-email`;
  const response = await intance.post(URL, value);
  return response;
};

export const checkEmailVerification = async (params) => {
  const URL = `auth/verify-email`;
  const response = await intance.get(URL, { params });
  return response;
};

export const getAllUsers = async (filter, search) => {
  let URL = `admin/users`;
  const params = {};
  if (filter) {
    params.filter = filter;
  }
  if (search) {
    params.search = search;
  }
  const response = await intance.get(URL, { params });
  return response;
};

export const getMyAuditors = async (page = 1, limit = 10, status = 1, templateId = null, siteId = null) => {
  const URL = `auditor/my-auditors`;
  const params = { page, limit, status };
  if (templateId) params.template_id = templateId;
  if (siteId) params.site_id = siteId;
  const response = await intance.get(URL, { params });
  return response;
};

export const getAllAuditors = async (page, limit, filter, search) => {
  let URL = `auditor`;
  const params = {
    page: page || 1,
    limit: limit || 10,
    sortOrder: 'DESC'
  };

  if (filter === 'all') {
    params.is_active_inactive = 1;
  } else if (filter === 'active') {
    params.status = 1;
  } else if (filter === 'inactive') {
    params.status = 0;
  } else if (filter) {
    params.filter = filter; // fallback for other filters
  }

  if (search) {
    params.search = search;
  }
  const response = await intance.get(URL, { params });
  return response;
};

export const createAuditor = async (data) => {
  const URL = `auditor`;
  const response = await intance.post(URL, data);
  return response;
};

export const getAuditorById = async (id) => {
  const URL = `auditor/${id}`;
  const response = await intance.get(URL);
  return response;
};

export const updateAuditor = async (id, data) => {
  const URL = `auditor/${id}`;
  const response = await intance.patch(URL, data);
  return response;
};

export const toggleAuditorStatus = async (id) => {
  const URL = `auditor/${id}/toggle-status`;
  const response = await intance.patch(URL);
  return response;
};

export const deleteAuditor = async (id) => {
  const URL = `auditor/${id}`;
  const response = await intance.delete(URL);
  return response;
};

export const assignAuditor = async (data) => {
  const URL = `auditor/assign-site`;
  const response = await intance.post(URL, data);
  return response;
};

export const getChapters = async (
  page = 1,
  limit = 10,
  sortBy = 'id',
  sortOrder = 'DESC',
  search = '',
  templateId = '',
  createdType = '',
  version = '',
  createFrom = '',
  isGlobal = '',
  includeDeleted = false,
  isClone = false,
  template_group = true,
  template_wise = true
) => {
  const URL = `Chapters`;
  const params = { page, limit, sortBy, sortOrder, search };
  if (templateId) params.template_id = templateId;
  if (createdType) params.created_type = createdType;
  if (version) params.version = version;
  if (createFrom) params.create_from = createFrom;
  if (isGlobal) params.isGlobal = isGlobal;
  if (includeDeleted !== undefined && includeDeleted !== '') params.includeDeleted = includeDeleted;
  if (isClone !== undefined && isClone !== '') params.isClone = isClone;
  if (template_group !== undefined && template_group !== '') params.template_group = template_group;
  if (template_wise !== undefined && template_wise !== '') params.template_wise = template_wise;
  const response = await intance.get(URL, { params });
  return response;
};

export const createChapter = async (data) => {
  const URL = `Chapters`;
  const response = await intance.post(URL, data);
  return response;
};

export const createGlobalChapter = async (data) => {
  const URL = `Chapters/global`;
  const response = await intance.post(URL, data);
  return response;
};

export const updateChapter = async (id, data) => {
  const URL = `Chapters/${id}`;
  const response = await intance.patch(URL, data);
  return response;
};

export const deleteChapter = async (id) => {
  const URL = `Chapters/${id}`;
  const response = await intance.delete(URL);
  return response;
};

export const getQuestionsByChapter = async (chapterId, siteChapterId = null, version = 1, search = '') => {
  let URL = `quetions/chapter/${chapterId}?version=${version}`;
  if (siteChapterId) {
    URL += `&siteChapterId=${siteChapterId}`;
  }
  if (search) {
    URL += `&search=${encodeURIComponent(search)}`;
  }
  const response = await intance.get(URL);
  return response;
};

export const getQuestionsByChapterId = async (chapterId, search = '') => {
  let URL = `quetions/by-chapter/${chapterId}`;
  if (search) {
    URL += `?search=${encodeURIComponent(search)}`;
  }
  const response = await intance.get(URL);
  return response;
};

export const fetchChapterQuestionsWithFlag = async (chapterId, templateId, flag = true) => {
  const URL = `quetions/by-chapter/${chapterId}?flag=${flag}&template_id=${templateId}`;
  const response = await intance.get(URL);
  return response;
};

export const getQuestionsByChapterAndTemplate = async (chapterId, templateId, search = '', version = null) => {
  let URL = `quetions/by-chapter-and-template/${chapterId}/${templateId}`;
  if (search) {
    URL += `?search=${encodeURIComponent(search)}`;
  }
  if (version) {
    URL += `?version=${version}`;
  }
  const response = await intance.get(URL);
  return response;
};

export const getQuestionsByTemplate = async (templateId, chapterId = null, search = '', siteChapterId = null, version = null) => {
  let URL = `quetions/template/${templateId}`;
  const params = [];
  if (chapterId) params.push(`chapterId=${chapterId}`);
  if (search) params.push(`search=${encodeURIComponent(search)}`);
  if (siteChapterId) params.push(`siteChapterId=${siteChapterId}`);
  if (version) params.push(`version=${version}`);

  if (params.length > 0) {
    URL += `?${params.join('&')}`;
  }
  const response = await intance.get(URL);
  return response;
};

export const reorderQuestions = async (chapterId, questionIds, templateId = null) => {
  const URL = `quetions/reorder`;
  const payload = {
    question_ids: questionIds,
    template_id: templateId !== null ? Number(templateId) : 0
  };
  const response = await intance.patch(URL, payload);
  return response;
};

export const createQuestion = async (data) => {
  const URL = `quetions`;
  const response = await intance.post(URL, data);
  return response;
};

export const updateQuestion = async (id, data) => {
  const URL = `quetions/${id}`;
  const response = await intance.patch(URL, data);
  return response;
};

export const getQuestionById = async (id) => {
  const URL = `quetions/${id}`;
  const response = await intance.get(URL);
  return response;
};

export const deleteQuestion = async (id) => {
  const URL = `quetions/${id}`;
  const response = await intance.delete(URL);
  return response;
};

export const getIbpReferences = async (page = 1, limit = 10, search = '') => {
  const URL = `ibp-reference`;
  const params = {
    page,
    limit
    // sortOrder: 'ASC'
  };
  if (search) {
    params.search = search;
  }
  const response = await intance.get(URL, { params });
  return response;
};

export const getAllIbpReferences = async () => {
  try {
    const firstRes = await getIbpReferences(1, 100);
    const fetched = firstRes?.data?.data?.items || firstRes?.data?.data?.records || firstRes?.data?.data || firstRes?.data || [];
    let items = Array.isArray(fetched) ? fetched : fetched.items || fetched.records || [];
    const total =
      firstRes?.data?.total ||
      firstRes?.data?.data?.total ||
      firstRes?.data?.data?.pagination?.total ||
      firstRes?.data?.total_count ||
      items.length;

    if (total > items.length && items.length > 0) {
      const pageSize = items.length;
      const totalPages = Math.ceil(total / pageSize);
      const promises = [];
      for (let p = 2; p <= totalPages; p++) {
        promises.push(getIbpReferences(p, pageSize));
      }
      const pageResults = await Promise.all(promises);
      pageResults.forEach((res) => {
        const pFetched = res?.data?.data?.items || res?.data?.data?.records || res?.data?.data || res?.data || [];
        const pItems = Array.isArray(pFetched) ? pFetched : pFetched.items || pFetched.records || [];
        items = items.concat(pItems);
      });
    }
    return items;
  } catch (err) {
    console.error('Error fetching all IBP references:', err);
    return [];
  }
};

export const getIbpReferenceById = async (id) => {
  const URL = `ibp-reference/${id}`;
  const response = await intance.get(URL);
  return response;
};

export const createIbpReference = async (formData) => {
  const URL = `ibp-reference`;
  const response = await intance.post(URL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response;
};

export const updateIbpReference = async (id, formData) => {
  const URL = `ibp-reference/${id}`;
  const response = await intance.patch(URL, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response;
};

export const deleteIbpReference = async (id) => {
  const URL = `ibp-reference/${id}`;
  const response = await intance.delete(URL);
  return response;
};

// ─── Site APIs ────────────────────────────────────────────────────────────────

export const getAllSites = async (page, limit, filter, search, extraParams = {}) => {
  const URL = `site`;
  const params = {
    page: page || 1,
    limit: limit || 10,
    status: 1
  };
  if (filter === 'active') {
    params.status = 1;
  } else if (filter === 'inactive') {
    params.status = 0;
  }

  // New fields from Swagger for server-side filtering
  if (extraParams.site_status) {
    params.site_status = extraParams.site_status;
  }
  if (extraParams.audit_type) {
    params.audit_type = extraParams.audit_type;
  }

  if (search) {
    params.search = search;
  }
  if (extraParams.sortOrder) {
    params.sortOrder = extraParams.sortOrder;
  }
  if (extraParams.fromDateTime) {
    params.fromDateTime = extraParams.fromDateTime;
  }
  if (extraParams.toDateTime) {
    params.toDateTime = extraParams.toDateTime;
  }
  if (extraParams.create) {
    params.create = extraParams.create;
  }
  if (extraParams.auditor_ids) {
    params.auditor_ids = extraParams.auditor_ids;
  }
  if (extraParams.has_prev_auditor !== undefined) {
    params.has_prev_auditor = extraParams.has_prev_auditor;
  }
  const response = await intance.get(URL, { params });
  return response;
};
export const getSiteById = async (id, version = null) => {
  const URL = version ? `site/${id}?version=${version}` : `site/${id}`;
  const response = await intance.get(URL);
  return response;
};

export const createSite = async (data) => {
  const URL = `site`;
  const response = await intance.post(URL, data);
  return response;
};

export const updateSite = async (data) => {
  const URL = `site`;
  const response = await intance.patch(URL, data);
  return response;
};

export const toggleSiteStatus = async (id) => {
  const URL = `site/${id}/toggle-status`;
  const response = await intance.patch(URL);
  return response;
};

export const deleteSite = async (data) => {
  const URL = `site`;
  const response = await intance.delete(URL, { data });
  return response;
};

export const getSiteAndBuildingSections = async (site_id, page = 1, limit = 10, version = null) => {
  const URL = version
    ? `site-and-building-section?site_id=${site_id}&page=${page}&limit=${limit}&sortOrder=DESC&version=${version}`
    : `site-and-building-section?site_id=${site_id}&page=${page}&limit=${limit}&sortOrder=DESC`;
  const response = await intance.get(URL);
  return response;
};

export const createSiteChapterMap = async (data) => {
  const URL = `site-and-building-section`;
  const response = await intance.post(URL, data);
  return response;
};

export const deleteSiteChapterMap = async (data) => {
  const URL = `site-and-building-section`;
  const response = await intance.delete(URL, { data });
  return response;
};

export const updateSiteChapterMap = async (data) => {
  const URL = `site-and-building-section`;
  const response = await intance.patch(URL, data);
  return response;
};

export const createBuilding = async (data) => {
  const URL = `site-and-building-section/buildings`;
  const response = await intance.post(URL, data);
  return response;
};

export const updateBuilding = async (data) => {
  const URL = `site-and-building-section/buildings`;
  const response = await intance.patch(URL, data);
  return response;
};

export const deleteBuilding = async (data) => {
  const URL = `site-and-building-section/buildings`;
  const response = await intance.delete(URL, { data });
  return response;
};

export const uploadAssessmentMedia = async (formData) => {
  const URL = `upload`;
  const response = await intance.post(URL, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response;
};

export const saveAssessmentResponse = async (data) => {
  const URL = `auditor-response`;
  const response = await intance.post(URL, data);
  return response;
};

export const completeAssessmentChapter = async (data) => {
  const URL = `site-assessment/complete-chapter`;
  const response = await intance.post(URL, data);
  return response;
};

export const submitAssessmentChapter = async (data) => {
  const URL = `auditor-response/submit`;
  const response = await intance.post(URL, data);
  return response;
};

export const getAuditorResponseHistory = async (chapterId, siteChapterId = null, templateId = null) => {
  const URL = `auditor-response/history`;
  const params = {};
  if (siteChapterId) params.siteChapterId = siteChapterId;
  if (templateId) params.templateId = templateId;

  return await intance.get(URL, { params });
};

// ─── Template APIs ────────────────────────────────────────────────────────────

export const getTemplates = async (page = 1, limit = 10, search = '', isGlobal = undefined, includeDeleted = undefined) => {
  const URL = `template`;
  const params = { page, limit };
  if (search) params.search = search;
  if (isGlobal !== undefined) params.isGlobal = isGlobal;
  if (includeDeleted !== undefined) params.includeDeleted = includeDeleted;
  const response = await intance.get(URL, { params });
  return response;
};

export const createTemplate = async (data) => {
  const URL = `template`;
  const response = await intance.post(URL, data);
  return response;
};

export const createGlobalTemplate = async (data) => {
  const URL = `template/global`;
  const response = await intance.post(URL, data);
  return response;
};

export const cloneTemplate = async (data) => {
  const URL = `template/clone`;
  const response = await intance.post(URL, data);
  return response;
};

export const updateTemplate = async (data) => {
  const URL = `template`;
  const response = await intance.patch(URL, data);
  return response;
};

export const deleteTemplate = async (id) => {
  const URL = `template/${id}`;
  const response = await intance.delete(URL);
  return response;
};

export const toggleTemplateStatus = async (id) => {
  const URL = `template/toggle-status`;
  const response = await intance.patch(URL, { id });
  return response;
};

export const getTemplateHistory = async (templateId, versionNumber) => {
  const URL = `template/history/${templateId}?version_number=${versionNumber}`;
  const response = await intance.get(URL);
  return response;
};

export const createFullReport = async (data) => {
  const URL = `full-report`;
  const response = await intance.post(URL, data);
  return response;
};

export const getGeneratedReports = async (params) => {
  const URL = `full-report/generated/all`;
  const searchParams = new URLSearchParams();
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          if (val !== undefined && val !== null) {
            searchParams.append(key, val);
          }
        });
      } else if (value !== undefined && value !== null) {
        searchParams.append(key, value);
      }
    });
  }
  const response = await intance.get(URL, { params: searchParams });
  return response;
};

export const getGeneratedReportDetails = async (siteId) => {
  const URL = `full-report/generated/details/${siteId}`;
  const response = await intance.get(URL);
  return response;
};

export const getFullReport = async (siteId, version = null, siteType = null) => {
  let URL = `full-report/${siteId}`;
  const params = [];
  if (version) params.push(`version=${version}`);
  // if (sectionId) params.push(`section_id=${sectionId}`);
  if (siteType) params.push(`site_type=${siteType}`);
  if (params.length > 0) {
    URL += `?${params.join('&')}`;
  }
  const response = await intance.get(URL);
  return response;
};

export const getEnhancedReport = async (siteId, version, baselineVersion) => {
  let URL = `enhanced-report?siteId=${siteId}&version=${version}`;
  if (baselineVersion) {
    URL += `&baselineVersion=${baselineVersion}`;
  }
  const response = await intance.get(URL);
  return response;
};

export const editFullReportHeader = async (data) => {
  const URL = `full-report/edit-data`;
  const response = await intance.patch(URL, data);
  return response;
};

export const sendFullReportEmail = async (data) => {
  const URL = `full-report/send-edit-email`;
  const response = await intance.post(URL, data);
  return response;
};

// ─── Delegate Admin APIs ────────────────────────────────────────────────────────

const mapApiPermissionsToState = (data) => {
  const getVal = (key) => {
    if (data.permissions && data.permissions[key] !== undefined) {
      return data.permissions[key];
    }
    return data[key];
  };

  const mapValue = (val) => {
    return {
      view: val === 0 || val === 1 || val === '0' || val === '1' || val === 0.0 || val === 1.0,
      manage: val === 1 || val === '1' || val === 1.0
    };
  };

  return {
    Dashboard: mapValue(getVal('dashboard')),
    'Manage Auditor': mapValue(getVal('manage_auditor')),
    'IBP Reference': mapValue(getVal('ibp_ref')),
    'Manage Template': mapValue(getVal('manage_template')),
    'Manage Chapter': mapValue(getVal('manage_chapter')),
    'My Audit': mapValue(getVal('my_audit')),
    'Auditor Audit': mapValue(getVal('auditor_audit')),
    'Audit Report': mapValue(getVal('audit_report')),
    'Manage Subscription': mapValue(getVal('manage_subscription')),
    'Manage Custom Role': mapValue(getVal('manage_custom_role')),
    'Manage Support Ticket': mapValue(getVal('manage_support_ticket')),
    access_tablet:
      getVal('access_tablet') !== undefined ? getVal('access_tablet') : getVal('access_table') !== undefined ? getVal('access_table') : 1
  };
};

const mapStatePermissionsToApi = (perms) => {
  const evaluateValue = (modulePerm) => {
    if (!modulePerm) return null;
    if (modulePerm.manage) return 1;
    if (modulePerm.view) return 0;
    return null;
  };

  return {
    dashboard: evaluateValue(perms.Dashboard),
    manage_auditor: evaluateValue(perms['Manage Auditor']),
    ibp_ref: evaluateValue(perms['IBP Reference']),
    manage_template: evaluateValue(perms['Manage Template']),
    manage_chapter: evaluateValue(perms['Manage Chapter']),
    auditor_audit: evaluateValue(perms['Auditor Audit']),
    audit_report: evaluateValue(perms['Audit Report']),
    manage_subscription: evaluateValue(perms['Manage Subscription']),
    manage_custom_role: evaluateValue(perms['Manage Custom Role']),
    manage_support_ticket: evaluateValue(perms['Manage Support Ticket']),
    my_audit: evaluateValue(perms['My Audit']),
    access_tablet: perms.access_tablet !== undefined ? perms.access_tablet : 1
  };
};

export const getAllDelegates = async (page = 1, limit = 10, status = 'all', search = '') => {
  const URL = `delegate-admin`;
  const params = { page, limit };

  if (status === 'active') {
    params.status = 1;
  } else if (status === 'inactive') {
    params.status = 0;
  }

  if (search) {
    params.search = search;
  }

  const response = await intance.get(URL, { params });
  return response;
};

export const createDelegate = async (data) => {
  const URL = `delegate-admin`;
  const permissions = mapStatePermissionsToApi(data.permissions || {});

  const payload = {
    full_name: data.full_name,
    email: data.email,
    phone: data.phone,
    country_code: Number(data.phone_prefix?.replace('+', '') || 1),
    gender: data.gender || 'Male',
    dob: data.dob || '1990-01-01',
    address: data.address || '',
    company_name: data.company_name,
    assigned_template_id: data.template_id || null,
    permissions
  };

  const response = await intance.post(URL, payload);
  return response;
};

export const getDelegateById = async (id) => {
  const URL = `delegate-admin/${id}`;
  const response = await intance.get(URL);

  if (response?.data?.data) {
    const item = response.data.data;
    item.permissions = mapApiPermissionsToState(item);
  }
  return response;
};

export const updateDelegate = async (id, data) => {
  const URL = `delegate-admin/${id}`;
  const permissions = mapStatePermissionsToApi(data.permissions || {});

  const payload = {
    full_name: data.full_name,
    phone: data.phone,
    country_code: Number(data.phone_prefix?.replace('+', '') || 1),
    gender: data.gender || 'Male',
    dob: data.dob || '1990-01-01',
    address: data.address || '',
    company_name: data.company_name,
    assigned_template_id: data.template_id || null,
    permissions
  };

  const response = await intance.patch(URL, payload);
  return response;
};

export const updateDelegateProfile = async (id, data) => {
  const URL = `delegate-admin/${id}/profile`;
  const payload = {
    full_name: data.full_name,
    phone: data.phone,
    country_code: data.country_code
  };
  const response = await intance.patch(URL, payload);
  return response;
};

export const toggleDelegateStatus = async (id) => {
  const URL = `delegate-admin/${id}/toggle-status`;
  const response = await intance.patch(URL);
  return response;
};

export const deleteDelegate = async (id) => {
  const URL = `delegate-admin/${id}`;
  const response = await intance.delete(URL);
  return response;
};

export const forceLogoutDelegate = async (id) => {
  const URL = `delegate-admin/${id}/force-logout`;
  const response = await intance.post(URL);
  return response;
};

export const assignDelegateTemplate = async (delegateId, templateId) => {
  const URL = `template`;
  const response = await intance.patch(URL, { auditor_ids: [delegateId], id: templateId });
  return response;
};

export const getDashboardData = async (params) => {
  const URL = `dashboard`;
  const response = await intance.get(URL, { params });
  return response;
};

export const getSuccessAnalysisDetails = async (params) => {
  const URL = `dashboard/success-analysis-details`;
  const response = await intance.get(URL, { params });
  return response;
};

export const updateProfile = async (data) => {
  const URL = `auth/update-profile`;
  const response = await intance.patch(URL, data);
  return response;
};

export const changePassword = async (data) => {
  const URL = `auth/set-password`;
  const response = await intance.post(URL, data);
  return response;
};

export const getClientAdmin = async (id) => {
  const URL = `auth/client-admin/${id}`;
  const response = await intance.get(URL);
  return response;
};

export const updateClientAdmin = async (id, data) => {
  const URL = `auth/client-admin/${id}`;
  const response = await intance.patch(URL, data);
  return response;
};

export const getRoles = async () => {
  const URL = `auth/roles`;
  return await intance.get(URL);
};

export const getIndustries = async () => {
  const URL = `auth/industries`;
  return await intance.get(URL);
};

export const getTutorials = async (page = 1, limit = 10, audience, search) => {
  let URL = `tutorials?page=${page}&limit=${limit}`;
  if (audience) {
    URL += `&audience=${audience}`;
  }
  if (search) {
    URL += `&search=${encodeURIComponent(search)}`;
  }
  return await intance.get(URL);
};

export const createTutorial = async (payload) => {
  const URL = `tutorials`;
  return await intance.post(URL, payload);
};

export const updateTutorial = async (id, payload) => {
  const URL = `tutorials/${id}`;
  return await intance.patch(URL, payload);
};

export const deleteTutorial = async (id) => {
  const URL = `tutorials/${id}`;
  return await intance.delete(URL);
};

export const getSuperAdminDashboard = async (params) => {
  const URL = `super-admin/dashboard`;
  return await intance.get(URL, { params });
};

export const getSuperAdminClientAdmins = async (params) => {
  const URL = `super-admin/dashboard/client-admins`;
  return await intance.get(URL, { params });
};

export const getSuperAdminClientAdminDetail = async (id) => {
  const URL = `super-admin/dashboard/client-admins/${id}`;
  return await intance.get(URL);
};

// ─── AI Assistant PDF APIs ────────────────────────────────────────────────────

export const createOpenAiDoc = async (data) => {
  return await intance.post('open-ai', data);
};

export const updateOpenAiDoc = async (id, data) => {
  return await intance.put(`open-ai/${id}`, data);
};

export const getOpenAiDocs = async () => {
  return await intance.get('open-ai');
};

export const deleteOpenAiDoc = async (id) => {
  return await intance.delete(`open-ai/${id}`);
};

export const askAiAssistant = async (query, openAiIdList = []) => {
  const URL = `search/aggregate`;
  const payload = {
    query: query,
    openAiId: openAiIdList
  };
  const response = await intance.post(URL, payload);
  return response;
};

export const getAiSearchCount = async () => {
  const URL = `open-ai/search-count`;
  const response = await intance.get(URL);
  return response;
};

export const getAuditLogs = async (params) => {
  return await intance.get('audit-log', { params });
};

export const getAuditLogUsers = async (params) => {
  return await intance.get('audit-log/users', { params });
};
